<div class="layout-content mt-3">
	<div *ngIf="loadingThGroups || savingThGroups" class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
	<div *ngIf="!loadingThGroups && !savingThGroups" class="grid">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1 mb-3">
			<i class="pi cm-alert text-yellow-700"></i>
			<div class="flex flex-column">
				<p-tag styleClass="pb-0" [value]="('NOTE_MAX_ONE_SITE_FOR_TH_GROUP' | translate)" severity="warning"></p-tag>
				<p-tag styleClass="pt-0" [value]="('NOTE_TRANSFER_TH_GROUP_IN_SITE' | translate)" severity="warning"></p-tag>
			</div>
		</div>
		<div [ngClass]="col4ResponsiveStd()" class="flex flex-column justify-content-start text-center" *ngFor="let group of thOwnedGroups;">
			<div class="flex justify-content-center align-items-center gap-3">
				<p-checkbox 
					[ngModel]="assigned(group)"
					[binary]="true"
					[disabled]="assigned(group)"
					(onChange)="onCheckChange($event.checked, group)"
					>
				</p-checkbox>
				<div class="flex flex-column justify-content-start gap-1">
					<div class="flex flex-row gap-1">
						<div>{{ 'GROUP' | translate }}:</div>
						<div class="font-semibold">{{ group.name | truncate:[35] }}</div>
					</div>
					<div class="flex flex-row gap-1">
						<div>{{ 'ASSOCIATED_SITE' | translate }}:</div>
						<div class="font-semibold">{{ getAssociatedSiteName(group.siteId) }}</div>
					</div>
				</div>
			</div>
			<!-- <small *ngIf="anyOpenTicketOn(site)" class="flex align-items-center justify-content-center text-50 pt-1">{{ 'SITE_HAS_OPEN_TICKETS' | translate }}</small> -->
		</div>
	</div>

	<div *ngIf="!loadingThGroups && !savingThGroups" class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle" (click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>